import styled, { css } from 'styled-components';

// rename to StyledModal
export const StyledModal = styled.div`
    ${({ theme }) => css`
        width: 100%;
        position: relative;
        border-radius: ${theme.uiBricks?.modalBorderRadius || theme.modalBorderRadius};
        background-color: ${theme.uiBricks?.modalBackgroundColor || theme.modalBackgroundColor};
        border: 1px solid ${theme.uiBricks?.modalWrapperBorderColor || theme.modalWrapperBorderColor};
        box-shadow: ${theme.uiBricks?.modalWrapperBoxShadow || theme.modalWrapperBoxShadow};

        .close-icon,
        .close-link-wrapper {
            display: none;
        }

        &.trade-in-modal-layer {
            z-index: 2000;
        }

        // ui-bricks' Modal sets overflow: auto on both the dialog and the body wrapper it renders
        // around children; neither takes a className, so reach them structurally from the backdrop.
        &.no-overflow {
            [data-testid='ui-bricks-modal'] > div {
                overflow: visible;

                > div {
                    overflow: visible;
                }
            }
        }
    `}
`;

export const Description = styled.p`
    ${({ theme }) => css`
        font-weight: 400;
        font-size: ${theme.uiBricks?.headlineFontSize || theme.headlineFontSize};
        color: #6d6d6d;
        margin-top: 0.5em;
    `}
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        font-weight: ${theme.uiBricks?.headerFontWeight || theme.headerFontWeight};
        font-size: 30px;
        margin: 0;
        color: ${theme.uiBricks?.pageTitleColor || theme.pageTitleColor};
    `}
`;
